var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.409,
    height: 47.212,
    viewBox: "0 0 35.409 47.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7027",
    "data-name": "Grupo 7027",
    transform: "translate(-769.606 -364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(767.606 364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2464",
    "data-name": "Trazado 2464",
    d: "M31.507,2.951A2.951,2.951,0,0,1,34.458,5.9V41.31a2.951,2.951,0,0,1-2.951,2.951H7.9A2.951,2.951,0,0,1,4.951,41.31V5.9A2.951,2.951,0,0,1,7.9,2.951ZM7.9,0A5.9,5.9,0,0,0,2,5.9V41.31a5.9,5.9,0,0,0,5.9,5.9H31.507a5.9,5.9,0,0,0,5.9-5.9V5.9a5.9,5.9,0,0,0-5.9-5.9Z",
    transform: "translate(0)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2465",
    "data-name": "Trazado 2465",
    d: "M4,3.475A1.475,1.475,0,0,1,5.475,2H26.131a1.475,1.475,0,0,1,1.475,1.475v5.9a1.475,1.475,0,0,1-1.475,1.475H5.475A1.475,1.475,0,0,1,4,9.377Zm0,11.8A1.475,1.475,0,0,1,5.475,13.8H8.426A1.475,1.475,0,0,1,9.9,15.278v2.951A1.475,1.475,0,0,1,8.426,19.7H5.475A1.475,1.475,0,0,1,4,18.229Zm0,8.852a1.475,1.475,0,0,1,1.475-1.475H8.426A1.475,1.475,0,0,1,9.9,24.131v2.951a1.475,1.475,0,0,1-1.475,1.475H5.475A1.475,1.475,0,0,1,4,27.081Zm0,8.852a1.475,1.475,0,0,1,1.475-1.475H8.426A1.475,1.475,0,0,1,9.9,32.983v2.951a1.475,1.475,0,0,1-1.475,1.475H5.475A1.475,1.475,0,0,1,4,35.934Zm8.852-17.7A1.475,1.475,0,0,1,14.328,13.8h2.951a1.475,1.475,0,0,1,1.475,1.475v2.951A1.475,1.475,0,0,1,17.278,19.7H14.328a1.475,1.475,0,0,1-1.475-1.475Zm0,8.852a1.475,1.475,0,0,1,1.475-1.475h2.951a1.475,1.475,0,0,1,1.475,1.475v2.951a1.475,1.475,0,0,1-1.475,1.475H14.328a1.475,1.475,0,0,1-1.475-1.475Zm0,8.852a1.475,1.475,0,0,1,1.475-1.475h2.951a1.475,1.475,0,0,1,1.475,1.475v2.951a1.475,1.475,0,0,1-1.475,1.475H14.328a1.475,1.475,0,0,1-1.475-1.475Zm8.852-17.7A1.475,1.475,0,0,1,23.18,13.8h2.951a1.475,1.475,0,0,1,1.475,1.475v2.951A1.475,1.475,0,0,1,26.131,19.7H23.18A1.475,1.475,0,0,1,21.7,18.229Zm0,8.852a1.475,1.475,0,0,1,1.475-1.475h2.951a1.475,1.475,0,0,1,1.475,1.475v11.8a1.475,1.475,0,0,1-1.475,1.475H23.18A1.475,1.475,0,0,1,21.7,35.934Z",
    transform: "translate(3.901 3.901)",
    fill: "#003082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadora);
export default __webpack_public_path__ + "static/media/calculadora.bc127a546462865f3e3875220afe3ace.svg";
export { ForwardRef as ReactComponent };